import { Component, OnInit } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { AppConstants } from "../../../app-constants";
import { RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [RouterLink, DatePipe]
})
export class FooterComponent implements OnInit {

  readonly date = new Date();
  links = AppConstants.links;
  isStaging: boolean = environment.production === false;
  constructor(
  ) { }

  ngOnInit() { }
}
